import { useEffect, useState } from 'react';
import Booked from '../../components/Consultant/consultations/Booked';
import axios from 'axios';
import Rejected from '../../components/Consultant/consultations/Rejected';
import Accpted from '../../components/Consultant/consultations/Accpted';
import NewRequests from '../../components/Consultant/consultations/NewRequests';
function ConsultantConsultations() {
    const [activeTab, setActiveTab] = useState("New Requests");
    const [consultationData, setConsultationData] = useState({
        Pending: [],
        Booked: [],
        Approved: [],
        Rejected: [],

    });
    const [consultants, setConsultants] = useState([]);

    const fetchConsultations = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            // console.error("Token not found");
            return;
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/consultation/consultant`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            const data = response.data?.data || {};
            // console.log(response);
            
            setConsultationData({
                Pending: data.Pending || [],
                Booked: data.Booked || [],
                "In Process": data["In Process"] || [],
                Approved: data.Approved || [],
                Rejected: data.Rejected || [],
            });
        } catch (error) {
            // console.error('Error fetching consultations:', error);
        }
    };

  

    useEffect(() => {


        fetchConsultations();
        
    }, []);
//    console.log(consultationData)
   
   
    const renderContent = () => {
        switch(activeTab) {
            case "New Requests":
                return <NewRequests consultations={consultationData["In Process"]} fetchConsultations={fetchConsultations}  />;
            case "Booked":
                return <Booked consultations={consultationData.Booked} fetchConsultations={fetchConsultations}  />;
            case "Accepted":
                return <Accpted consultations={consultationData.Approved} fetchConsultations={fetchConsultations} />;
            case "Rejected":
                return <Rejected consultations={consultationData.Rejected} fetchConsultations={fetchConsultations} />;
            default:
                return <NewRequests consultations={consultationData["In Process"]} fetchConsultations={fetchConsultations}  />;
        }
    };

    return (
        <div className="relative pl-36 pr-12 mt-16 w-full py-8 bg-[#f4f8fb] h-screen">
            <div className="px-10 py-6 bg-white rounded shadow-md">
                <div className="flex mb-4 w-full border-b">
                    {['New Requests',  'Booked', 'Accepted', 'Rejected'].map((tab) => (
                        <button
                            key={tab}
                            className={`px-4 py-2 text-lg font-semibold flex-1 text-center ${activeTab === tab ? "text-blue-500 border-b-2 border-blue-500" : "text-gray-600"}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                {renderContent()}
            </div>
        </div>
    );
}

export default ConsultantConsultations;
